const infoAdminInitialState = {
    userId: 0,
    isAdmin: false,
    isMenuAdmin: false
}
const infoAdminReducer = (state = infoAdminInitialState, action) => {
    switch (action.type) {
        case 'updateInfoAdmin':
            return { ...state, userId: action.item.userId, isAdmin: action.item.isAdmin };
        case 'updatePageAdmin':
            return { ...state, isMenuAdmin: action.item.isMenuAdmin };
        default:
            return state
    }
}

export default infoAdminReducer;